(function () {
  function init() {
    var isChrome =
      /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    var stickyBarEl = document.querySelector('.pdp-sticky-bar');

    if (isChrome && stickyBarEl) {
      stickyBarEl.classList.add('chrome-style');
    }

    // Set --header-height variable if it's not already set by sticky-header
    function setHeaderHeight() {
      var currentHeight = getComputedStyle(
        document.documentElement
      ).getPropertyValue('--header-height');
      if (!currentHeight || currentHeight.trim() === '') {
        var headerGroup = document.querySelector(
          '.shopify-section-group-header-group'
        );
        if (headerGroup) {
          document.documentElement.style.setProperty(
            '--header-height',
            Math.max(0, headerGroup.getBoundingClientRect().bottom) + 'px'
          );
        }
      }
    }

    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Sticky pricing: detect when price block scrolls off screen and activate .pdp-sticky-bar
// the price display between the inline (price-regular) and sticky (price-sticky) views.
//
// APPROACH: scroll handler + rAF, but using window.scrollY and offsetTop instead of
// getBoundingClientRect(). The key insight is that iOS Safari's toolbar animation
// changes the *visual* viewport height (window.visualViewport.height / window.innerHeight)
// but does NOT change window.scrollY (the layout scroll position). getBoundingClientRect()
// returns visual-viewport-relative coordinates, so it oscillates during toolbar animation.
// window.scrollY does not — making it safe to read in the rAF scroll path.
//
// sentinelDocTop is computed via offsetTop chain (layout-based, not visual-viewport-based),
// so it is also immune to iOS toolbar oscillation.
//
// Condition: window.scrollY + headerHeight >= sentinelDocTop
//   → The user has scrolled far enough that the element's natural position would be
//     above the sticky threshold → bar should activate.
//
// .pdp-sticky-bar is moved to <body> at runtime to escape any ancestor with a CSS
// transform (e.g. .animate--slide), which would otherwise make position:fixed
// relative to that ancestor instead of the viewport. A zero-height sentinel is
// inserted in the original product-column position for scroll-trigger detection.
(function () {
  var stickyBar = document.querySelector('.pdp-sticky-bar');
  if (!stickyBar) return;

  var priceSticky = stickyBar.querySelector('.price-sticky');
  if (!priceSticky) return;

  // DC button container — seeded at runtime by seedStickyPaymentButton() below.
  var stickyPaymentButtons = stickyBar.querySelector('.sticky-payment-buttons');

  // APO configure container — seeded at runtime by the APO observer below.
  // apoSeeded gates visibility: proxy never shown until APO button is confirmed.
  var stickyConfigureContainer = stickyBar.querySelector(
    '.sticky-configure-container'
  );
  var apoSeeded = false;

  // Spacer that holds the bar's natural-flow height when it goes position:fixed,
  // preventing the layout collapse that causes CLS.
  var barSpacer = document.querySelector('.pdp-sticky-bar-spacer');
  if (!barSpacer)
    console.warn(
      '[pdp-sticky-bar] spacer element not found — CLS prevention disabled'
    );

  // Insert sentinel at original DOM position before moving stickyBar.
  // Must set display:block — base.css has `div:empty { display:none }` which would
  // make offsetParent null and break getDocTop position measurement.
  // overflow:hidden is a safeguard to ensure the element remains zero-height.
  var sentinel = document.createElement('div');
  sentinel.style.cssText =
    'height:0;display:block;visibility:hidden;pointer-events:none;overflow:hidden;';
  stickyBar.parentNode.insertBefore(sentinel, stickyBar);

  // Move to <body> — position:fixed now correctly tracks the viewport.
  document.body.appendChild(stickyBar);

  // Screen reader live region — politely announces when sticky bar activates.
  // Separate from price__sticky's aria-live (which handles price updates);
  // this announces the bar's availability to keyboard/SR users.
  var srAnnouncer = document.createElement('div');
  srAnnouncer.setAttribute('aria-live', 'polite');
  srAnnouncer.setAttribute('aria-atomic', 'true');
  srAnnouncer.style.cssText =
    'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;';
  document.body.appendChild(srAnnouncer);

  var headerHeight = 0;
  var sentinelDocTop = 0;
  var rafPending = false;
  var barIsActive = false;

  function setBarActive(isActive) {
    // Freeze guard: the Quick Config Advanced drawer uses position:fixed body-locking
    // which zeroes window.scrollY — a lock artifact, not a real user scroll. Any
    // setBarActive call fired during the lock would incorrectly collapse the bar.
    // The guard is cleared by closeAdvanced() before it dispatches the re-evaluation
    // scroll event, so state updates resume exactly when the drawer closes.
    if (document.body.classList.contains('qc-advanced-open')) return;
    if (isActive === barIsActive) return;
    // Size spacer BEFORE the class toggle — offsetHeight reflects natural-flow
    // height here; it collapses to 0 once pdp-sticky-bar--active (position:fixed)
    // is applied, so we must capture it first to prevent CLS.
    if (barSpacer)
      barSpacer.style.height = isActive ? stickyBar.offsetHeight + 'px' : '0';
    barIsActive = isActive;
    stickyBar.classList.toggle('pdp-sticky-bar--active', isActive);
    document.body.classList.toggle('pdp-sticky-bar-active', isActive);
    priceSticky.style.display = isActive ? '' : 'none';
    if (stickyPaymentButtons) {
      // APO guard: MageWorx APO injects .mw-apo-container to enforce required-option
      // validation before checkout. When APO is active it removes the main DC button
      // for the same reason. Our sticky DC button must honour that gate — hide it on
      // APO product pages so customers can't bypass required-option validation.
      var isApoPage = !!document.querySelector(
        '.mw-apo-container, .mw-apo-add-to-cart-custom'
      );
      stickyPaymentButtons.style.display = isActive && !isApoPage ? '' : 'none';
    }
    // APO configure container: show only when active AND APO seeding is complete.
    // The apoSeeded gate ensures customers never see a proxy button before APO's
    // own validated button exists — bypassing APO validation would be a hard failure.
    if (stickyConfigureContainer) {
      stickyConfigureContainer.style.display =
        isActive && apoSeeded ? '' : 'none';
    }
    // Sync aria-hidden: bar is accessible only when visually present.
    // Prevents screen readers encountering orphaned content at bottom of <body>.
    // NOTE: quick-config.js temporarily overrides this attribute while its
    // aria-modal Advanced drawer is open (sets 'true' on open, restores from
    // the pdp-sticky-bar--active class on close) — see openAdvanced/closeAdvanced.
    stickyBar.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    // Politely announce bar activation so keyboard/SR users know it's available.
    if (isActive) {
      srAnnouncer.textContent = '';
      requestAnimationFrame(function () {
        srAnnouncer.textContent = 'Price summary available';
      });
    }
  }

  // Walk the offsetParent chain to get the element's absolute document position.
  // offsetTop is layout-based and unaffected by iOS Safari toolbar animation.
  function getDocTop(el) {
    var top = 0;
    while (el && el !== document.body) {
      top += el.offsetTop;
      el = el.offsetParent;
    }
    return top;
  }

  // Evaluate bar activation using only layout-stable values.
  // Called inside rAF — no getBoundingClientRect, no visual-viewport dependency.
  function updateBarState() {
    rafPending = false;
    setBarActive(window.scrollY + headerHeight >= sentinelDocTop);
  }

  // Scroll: rAF-throttled. window.scrollY is stable during iOS Safari toolbar animation.
  window.addEventListener(
    'scroll',
    function () {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(updateBarState);
    },
    { passive: true }
  );

  // Recompute header height and sentinel document position, then re-evaluate.
  // Sentinel always stays in normal document flow so getDocTop is always accurate.
  // WARNING: This logic is tightly coupled to the theme's header structure.
  // Changes to header classes like '.utility-bar--sticky' or the 'sticky-header'
  // component may require updating the height calculation below.
  function handleLayoutChange() {
    var headerGroup = document.querySelector(
      '.shopify-section-group-header-group'
    );
    if (!headerGroup) {
      headerHeight = 0;
    } else {
      // Use offsetHeight (scroll-position-independent) throughout.
      // The announcement-bar section may render an outer container with CSS padding
      // even when no announcements are active (e.g. social icons enabled).
      // .utility-bar--sticky is only present when the sticky_bar setting is on,
      // so its absence means the bar scrolls away and shouldn't add to our offset.
      var utilityBar = headerGroup.querySelector('.utility-bar--sticky');
      var stickyNav = headerGroup.querySelector('sticky-header');
      headerHeight =
        utilityBar && utilityBar.offsetHeight > 0
          ? headerGroup.offsetHeight
          : stickyNav
            ? stickyNav.offsetHeight
            : 0;
    }
    // Measure sentinel position — it stays in the product column, so this is always
    // the true document-position of the price block regardless of stickyBar state.
    sentinelDocTop = getDocTop(sentinel);
    updateBarState();
  }

  // Initial measurement: DOM is parsed (readyState === 'interactive') when this
  // defer script runs, so call immediately rather than waiting for DOMContentLoaded.
  handleLayoutChange();
  // Re-evaluate after all images load — images above the price block affect sentinelDocTop.
  window.addEventListener('load', handleLayoutChange);
  window.addEventListener('resize', handleLayoutChange, { passive: true });
  // orientationchange: iOS viewport takes ~300 ms to settle after rotation.
  window.addEventListener(
    'orientationchange',
    function () {
      setTimeout(handleLayoutChange, 300);
    },
    { passive: true }
  );
  // header:update: fired when header height changes dynamically (e.g. dismissible bar).
  document.body.addEventListener('header:update', handleLayoutChange);

  // Seed the sticky payment button container. Two paths:
  //
  // PATH A — DC present: clone [data-shopify="payment-button"] so Shopify's SDK
  //   re-initialises the shopify-accelerated-checkout web component on the clone.
  //   A MutationObserver keeps variant-params in sync with the native element.
  //
  // PATH B — DC absent: surface a proxy ATC button that forwards clicks to the
  //   native .product-form__submit button. Mirrors its disabled state so sold-out
  //   variants correctly disable the sticky button too.
  //
  // APO products: the APO guard in setBarActive() hides this container entirely,
  // so no extra logic is needed here for either path.
  if (stickyPaymentButtons) {
    (function seedStickyPaymentButton() {
      var nativeDC = document.querySelector(
        '.product-form__buttons [data-shopify="payment-button"]'
      );

      // PATH B: ATC proxy — used when DC is absent OR when the DC clone fails to
      // render (shopify-accelerated-checkout web component doesn't always reinitialise
      // after cloneNode, leaving the clone with zero height).
      function seedAtcProxy() {
        var nativeATC = document.querySelector(
          '.product-form__buttons .product-form__submit'
        );
        if (!nativeATC) return;

        var proxyATC = document.createElement('button');
        proxyATC.type = 'button';
        proxyATC.id = 'sticky-atc-proxy-btn';
        proxyATC.className = 'sticky-atc-proxy-btn button button--primary';
        var span = nativeATC.querySelector('span');
        proxyATC.textContent = span
          ? span.textContent.trim()
          : stickyBar.dataset.addToCartLabel || 'Add to cart';
        proxyATC.disabled = nativeATC.disabled;
        // Inherit aria-label so screen readers announce the correct action.
        var nativeLabel = nativeATC.getAttribute('aria-label');
        if (nativeLabel) proxyATC.setAttribute('aria-label', nativeLabel);
        proxyATC.setAttribute('data-track-click', 'add_to_cart');
        proxyATC.setAttribute('data-track-section', 'pdp_sticky');
        proxyATC.setAttribute('data-track-label', 'Add to Cart');
        proxyATC.addEventListener('click', function (e) {
          // APO guard: forwarding nativeATC.click() on an APO product bypasses
          // MageWorx's required-option validation and adds the raw unconfigured
          // product to cart (verified live 2026-07-06: $1,440 base product with
          // zero option properties submitted). The APO-validated path is exposed
          // via the sticky APO proxy (.sticky-apo-proxy-btn), not this button.
          // Both guards stopPropagation so the swallowed click never reaches the
          // document-level analytics listener — this button carries
          // data-track-click="add_to_cart" and letting the click bubble would
          // record a cart add that never happened.
          if (
            document.querySelector(
              '.mw-apo-container, .mw-apo-add-to-cart-custom'
            )
          ) {
            if (stickyPaymentButtons)
              stickyPaymentButtons.style.display = 'none';
            // Hiding the container drops focus to <body> if the button was
            // keyboard-focused; blur explicitly so focus lands predictably
            // (WCAG 2.4.3) instead of silently vanishing mid-tab-sequence.
            if (document.activeElement && document.activeElement.blur)
              document.activeElement.blur();
            e.stopPropagation();
            return;
          }
          // Loading-options guard: the native button still contains the
          // server-rendered APO placeholder text before MageWorx finishes
          // injecting its UI (pre-APO-injection window on slow connections,
          // see snippets/buy-buttons.liquid). Forwarding at this moment
          // submits the product with no option data (same raw-add risk).
          if (/loading options/i.test(nativeATC.textContent)) {
            e.stopPropagation();
            return;
          }
          nativeATC.click();
        });
        stickyPaymentButtons.appendChild(proxyATC);

        // While the native button still shows the APO "Loading options…" placeholder the
        // proxy must not be exposed to assistive tech (it would announce a label that is not
        // an action). Hidden again from AT until the real label is mirrored in.
        function setProxyLoadingState(isLoading) {
          if (isLoading) {
            proxyATC.setAttribute('aria-hidden', 'true');
            proxyATC.setAttribute('tabindex', '-1');
          } else {
            proxyATC.removeAttribute('aria-hidden');
            proxyATC.removeAttribute('tabindex');
          }
        }
        setProxyLoadingState(/loading options/i.test(proxyATC.textContent));

        // Mirror disabled state, text, and aria-label so variant switches keep the
        // sticky button in sync. Intentionally not disconnected — page-lifetime observer.
        var atcObserver = new MutationObserver(function () {
          proxyATC.disabled = nativeATC.disabled;
          var s = nativeATC.querySelector('span');
          if (s) {
            proxyATC.textContent = s.textContent.trim();
            setProxyLoadingState(/loading options/i.test(proxyATC.textContent));
          }
          var updatedLabel = nativeATC.getAttribute('aria-label');
          if (updatedLabel) proxyATC.setAttribute('aria-label', updatedLabel);
          else proxyATC.removeAttribute('aria-label');
        });
        atcObserver.observe(nativeATC, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-label'],
          subtree: true,
          childList: true,
          characterData: true,
        });
      }

      if (!nativeDC) {
        // No DC button at all — go straight to PATH B.
        seedAtcProxy();
        return;
      }

      // PATH A: clone DC button.
      var clone = nativeDC.cloneNode(true);
      clone.removeAttribute('data-ju-checkout-wired');
      stickyPaymentButtons.appendChild(clone);

      var variantParamsObserver = null;
      var nativeAccel = nativeDC.querySelector('shopify-accelerated-checkout');
      var cloneAccel = clone.querySelector('shopify-accelerated-checkout');
      if (nativeAccel && cloneAccel) {
        variantParamsObserver = new MutationObserver(function (muts) {
          muts.forEach(function (m) {
            if (m.attributeName === 'variant-params') {
              var val = nativeAccel.getAttribute('variant-params');
              if (val !== null) cloneAccel.setAttribute('variant-params', val);
            }
          });
        });
        variantParamsObserver.observe(nativeAccel, {
          attributes: true,
          attributeFilter: ['variant-params'],
        });
      }

      // Fallback: if shopify-accelerated-checkout fails to reinitialise, tear it down
      // and use the ATC proxy instead so the sticky bar always has a purchase CTA.
      //
      // dcInitialized is set true when RO observes height > 0. Using a flag rather than
      // offsetHeight in the timer — offsetHeight is 0 when sticky-payment-buttons is
      // display:none (bar not yet active), which would cause a false fallback.
      //
      // ResizeObserver is feature-detected for iOS 12 safety (throws ReferenceError if
      // missing; the 2s timer is the authoritative fallback in that case).
      // We do NOT clearTimeout in the RO callback so the 2s check always runs —
      // this handles the edge case where the DC component briefly renders then collapses.
      var dcInitialized = false;
      var cloneRO =
        typeof ResizeObserver !== 'undefined'
          ? new ResizeObserver(function (entries) {
              if (entries[0].contentRect.height > 0) {
                dcInitialized = true;
                cloneRO.disconnect();
              }
            })
          : null;
      if (cloneRO) cloneRO.observe(clone);

      // At 2s, if DC component never rendered stably (or briefly rendered then
      // collapsed — e.g. Shop Pay initialising then dying on mobile), fall back to
      // the ATC proxy. Checking current height in addition to the flag handles the
      // "brief render then collapse" edge case where dcInitialized was set true but
      // the component is no longer visible.
      setTimeout(function () {
        if (cloneRO) cloneRO.disconnect();
        var accelEl = clone.querySelector('shopify-accelerated-checkout');
        var currentlyVisible =
          (accelEl ? accelEl.offsetHeight : clone.offsetHeight) > 0;
        if (!dcInitialized || !currentlyVisible) {
          if (variantParamsObserver) variantParamsObserver.disconnect();
          if (clone.parentNode === stickyPaymentButtons)
            stickyPaymentButtons.removeChild(clone);
          seedAtcProxy();
        }
      }, 2000);
    })();
  }

  // APO sticky configure button: detect MageWorx APO injection and surface a proxy
  // "Buy now" button in the sticky bar that forwards taps to APO's own validated
  // .mw-apo-buy-it-now-cloned button. APO enforces required-option completion —
  // we never bypass that gate. The proxy is shown only after APO confirms injection.
  //
  // IMPORTANT: use only the *cloned* APO buttons — they carry APO's required-field
  // validation and correct cart payload. .mw-apo-add-to-cart-custom does NOT fully
  // replicate that behaviour. Prefer buy-it-now-cloned (direct checkout) but fall
  // back to add-to-cart-cloned for products where Buy It Now is disabled in APO.
  //
  // Detection strategy: MutationObserver on document.body (broad scope) so we catch
  // APO buttons regardless of where in the DOM APO injects them. APO sometimes injects
  // outside .product-form__buttons; the previous narrow-scope observer silently missed
  // it. Observing body is acceptable — APO's injection is a one-time event; we
  // disconnect immediately once found.
  //
  // The 6-second timeout is the only mechanism for determining a page is non-APO:
  // "APO is still loading" and "APO will never inject" are indistinguishable earlier.
  (function seedStickyApoButton() {
    // Prefer the Buy It Now clone (direct checkout); fall back to ATC clone when
    // Buy It Now is disabled in APO settings (hidden-bookcase-door case).
    // Both clones carry APO's required-field validation — clicking our proxy
    // forwards to apoBtn.click() so APO's own handler runs.
    var APO_BUTTON_SELECTOR =
      '.mw-apo-buy-it-now-cloned, .mw-apo-add-to-cart-cloned';
    // How long to wait for APO injection before giving up (ms).
    // This is the only signal that distinguishes "non-APO page" from "APO loading slowly".
    var APO_INJECTION_TIMEOUT_MS = 6000;

    if (!stickyConfigureContainer) return;

    function wire(apoBtn) {
      var proxyBtn = document.createElement('button');
      proxyBtn.type = 'button';
      proxyBtn.className = 'sticky-apo-proxy-btn button button--primary';
      // The label names what a tap does: it mirrors the APO button it forwards to, ONCE,
      // and is never relabeled afterwards. It used to flip to "Select options" while
      // required options were missing and back again, so the same button read as two
      // different actions (D8-17). Missing options are now signalled by APO's own
      // scroll-to-field + inline error, the validation shake, a live-region announcement
      // and the data-options-incomplete marker, never by changing the button's name.
      // The fallback follows the forward target, so an ATC clone never reads "Buy now".
      proxyBtn.textContent =
        apoBtn.textContent.trim() ||
        (apoBtn.classList.contains('mw-apo-add-to-cart-cloned')
          ? 'Add to cart'
          : 'Buy now');
      // No aria-label: the button text IS the accessible name (WCAG 2.5.3).
      // Analytics name what the tap DOES, following the forward target exactly like the
      // visible label above. The Buy-It-Now clone goes straight to checkout, so it reports
      // `buy_now` (a taxonomy verb), never `add_to_cart`: a fake add_to_cart inflates the
      // ATC funnel/rate and the Elevar/GA4/Meta add-to-cart lanes. Only the ATC-clone
      // fallback (Buy It Now disabled in APO, e.g. hidden-bookcase-door) truly adds to the
      // cart, so only that path keeps `add_to_cart`. Real checkout events fired by Shopify
      // or Elevar after APO redirects are untouched; this is only the click label.
      var isAtcClone = apoBtn.classList.contains('mw-apo-add-to-cart-cloned');
      proxyBtn.setAttribute(
        'data-track-click',
        isAtcClone ? 'add_to_cart' : 'buy_now'
      );
      proxyBtn.setAttribute('data-track-section', 'pdp_sticky');
      proxyBtn.setAttribute(
        'data-track-label',
        isAtcClone ? 'Add to Cart' : 'Buy Now'
      );
      // Forward taps to APO's button — APO handles validation, scroll-to-field, and checkout.
      proxyBtn.addEventListener('click', function () {
        apoBtn.click();
      });
      // replaceChildren not available on iOS Safari < 15.4 or Samsung Internet < 14.
      while (stickyConfigureContainer.firstChild) {
        stickyConfigureContainer.removeChild(
          stickyConfigureContainer.firstChild
        );
      }
      stickyConfigureContainer.appendChild(proxyBtn);

      apoSeeded = true;
      // If the bar is already active when seeding completes, show/hide immediately without
      // waiting for the next scroll event — user may have scrolled before APO finished.
      // Also hide stickyPaymentButtons so the native ATC proxy (which bypasses APO's
      // required-field validation) is never shown alongside the APO-validated proxy.
      if (barIsActive) {
        stickyConfigureContainer.style.display = '';
        if (stickyPaymentButtons) stickyPaymentButtons.style.display = 'none';
      }

      // Watch APO required-field error divs so a screen-reader user hears that options
      // are missing (sighted users get APO's scroll-to-field and inline error). The label
      // itself never changes. data-options-incomplete is shared with the validate-failed
      // path in mws_apo_helper.liquid so one tap announces once, not twice. This uses
      // direct DOM observation rather than APO's onEvent callback system, which is not
      // invoked on all product/APO configurations.
      //
      // Every "options missing" signal goes through announce(). A live region only speaks
      // a CHANGE, so a second failed tap used to be silent: the required error was already
      // visible (no class mutation), the marker guard skipped it, and re-writing the same
      // sentence is not a change. announce() empties the region, refills it two frames
      // later, and alternates a trailing no-break space so a repeat is a new string. Calls
      // for the same message while one is still pending (validate-failed + observer + tap
      // check all land within the same tap, before the next frame) collapse into one.
      var MISSING_OPTIONS_MSG =
        'Required options not completed. Please select all required options.';
      var pendingAnnounce = '';
      var announceFlip = false;
      function announce(message) {
        if (!srAnnouncer || !message || message === pendingAnnounce) return;
        pendingAnnounce = message;
        announceFlip = !announceFlip;
        var text = announceFlip ? message : message + '\u00A0';
        srAnnouncer.textContent = '';
        // Double rAF ensures VoiceOver on iOS 15-17 registers the clear-then-set as two
        // distinct mutation events.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            srAnnouncer.textContent = text;
            pendingAnnounce = '';
          });
        });
      }

      var apoContainer = document.querySelector('.mw-apo-container');
      if (apoContainer) {
        // Store so we can disconnect on pagehide (iOS bfcache safety).
        var requiredFieldObserver = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            var el = mutation.target;
            if (el.getAttribute('data-helptext-type') !== 'required') return;
            if (!el.classList.contains('mw-hidden')) {
              // Required error became visible: configuration is incomplete. A duplicate in
              // the same tick (validate-failed already announced) is collapsed by announce().
              proxyBtn.setAttribute('data-options-incomplete', 'true');
              announce(MISSING_OPTIONS_MSG);
            } else {
              // Required error was hidden: the customer filled this field.
              var remaining = apoContainer.querySelectorAll(
                'div[data-helptext-type="required"]:not(.mw-hidden)'
              ).length;
              if (remaining === 0) {
                proxyBtn.removeAttribute('data-options-incomplete');
              }
            }
          });
        });
        requiredFieldObserver.observe(apoContainer, {
          attributes: true,
          attributeFilter: ['class'],
          subtree: true,
        });
        // A repeat failed tap leaves the already-visible required error untouched, so the
        // observer above sees nothing. Registered after the forwarding listener, so APO has
        // validated by the time this runs: if a required error is showing, say so again.
        proxyBtn.addEventListener('click', function () {
          setTimeout(function () {
            var missing = apoContainer.querySelector(
              'div[data-helptext-type="required"]:not(.mw-hidden)'
            );
            if (!missing) return;
            proxyBtn.setAttribute('data-options-incomplete', 'true');
            announce(MISSING_OPTIONS_MSG);
          }, 0);
        });
        window.addEventListener('pagehide', function () {
          requiredFieldObserver.disconnect();
        });
      }

      // Bridge for mws_apo_helper.liquid's onClick::validate-failed path (products where
      // mwApoCustom() is called). Receives sticky-bar:announce events and pipes them through
      // the srAnnouncer live region so screen readers hear the state change.
      document.body.addEventListener('sticky-bar:announce', function (e) {
        if (!e.detail || !e.detail.message) return;
        announce(e.detail.message);
      });
    }

    // Immediate check — APO may have injected synchronously before this script ran.
    var existing = document.querySelector(APO_BUTTON_SELECTOR);
    if (existing) {
      wire(existing);
      return;
    }

    // APO button not yet present — observe document.body so we catch the injection
    // regardless of where in the DOM APO inserts the button.
    var giveUpTimer;
    var apoObserver = new MutationObserver(function () {
      var btn = document.querySelector(APO_BUTTON_SELECTOR);
      if (!btn) return;
      clearTimeout(giveUpTimer);
      apoObserver.disconnect();
      wire(btn);
    });
    apoObserver.observe(document.body, { childList: true, subtree: true });

    // Timeout: if APO never injects its button, disconnect and stay in support-only mode.
    // Non-APO pages reach this path — the observer has been idle the whole time,
    // so disconnect is the only cost.
    giveUpTimer = setTimeout(function () {
      apoObserver.disconnect();
    }, APO_INJECTION_TIMEOUT_MS);
  })();

  // Sync sticky thumbnail whenever the active gallery slide changes.
  // Two update paths observed:
  //   1. Native variant selects: setActiveMedia() adds is-active to the slide element.
  //   2. APO (MageWorx): skips setActiveMedia entirely and directly swaps img src
  //      using the "Product gallery active image" CSS selector configured in APO settings.
  //      APO products have no <variant-selects> so variant-change pubsub never fires.
  // Both paths are handled below via a single MutationObserver on class + src changes.
  var stickyThumb = stickyBar
    ? stickyBar.querySelector('.product-thumbnail')
    : null;
  if (stickyThumb) {
    var galleryList = document.querySelector(
      '#MediaGallery-' + stickyBar.dataset.sectionId + ' .product__media-list'
    );
    if (galleryList) {
      // data-media-id suffix used by media-gallery.js to identify the composite canvas slide.
      var CONFIGURATOR_SLIDE_ID_FRAGMENT = 'configurator';

      // Re-point the sticky thumbnail at a 100px render of whatever the gallery
      // is currently showing.
      //
      // 🚨 Do NOT do this with string surgery on the query string. The original
      // implementation stripped /[?&]width=\d+/ and re-appended `width=100`,
      // which silently destroyed the URL whenever `width` was the FIRST query
      // parameter: deleting `?width=800` takes the `?` with it, so the remaining
      // params fuse onto the PATH and the re-appended `?width=100` lands after
      // them:
      //   .../<hash>?width=800&height=1200&is_webp=true
      //     -> .../<hash>&height=1200&is_webp=true?width=100   (HTTP 404)
      // Shopify CDN URLs hid the bug for the entire life of this function
      // because they order params `?v=<ts>&width=<n>` -- width is never first,
      // so only `&width=` was removed and the `?v=` survived. MageWorx APO puts
      // width FIRST, so every APO gallery swap produced a 404 thumbnail, which
      // MageWorx then retried three times (`mw_img_retry=3`, `data-mw-img-origin`)
      // before giving up on a blank image. That is why this looked intermittent:
      // it tracked the image HOST, not the page.
      // URLSearchParams.set() replaces the key in place when present and appends
      // only when absent, so it is correct for both hosts at any param order.
      function updateStickyThumb(rawSrc) {
        var next = rawSrc;
        try {
          var url = new URL(rawSrc, window.location.href);
          // Only rewrite real network URLs. A data:/blob: lazy-load placeholder
          // has no query string, and appending one corrupts the payload.
          if (url.protocol === 'http:' || url.protocol === 'https:') {
            url.searchParams.set('width', '100');
            next = url.href;
          }
        } catch (e) {
          // Malformed src -- use it verbatim rather than assigning a broken URL.
        }
        stickyThumb.src = next;
      }

      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          var el = mutation.target;

          if (mutation.attributeName === 'class') {
            // PATH 1: native variant selects — setActiveMedia adds is-active to the slide.
            if (
              !el.classList.contains('is-active') ||
              !el.classList.contains('product__media-item')
            )
              return;
            if (
              el.dataset.mediaId &&
              el.dataset.mediaId.includes(CONFIGURATOR_SLIDE_ID_FRAGMENT)
            )
              return;
            var img = el.querySelector('img');
            if (img && img.src) updateStickyThumb(img.src);
          } else if (mutation.attributeName === 'src') {
            // PATH 2: APO — directly swaps the img src on the gallery element.
            if (el.tagName !== 'IMG' || !el.src) return;
            var slide = el.closest('.product__media-item');
            if (!slide) return;
            if (
              slide.dataset.mediaId &&
              slide.dataset.mediaId.includes(CONFIGURATOR_SLIDE_ID_FRAGMENT)
            )
              return;
            updateStickyThumb(el.src);
          }
        });
      }).observe(galleryList, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class', 'src'],
      });
    }
  }
})();

// CLS Stabilizer for MageWorx APO (Advanced Product Options)
//
// Problem: APO dynamically shows/hides option groups via display:none/block
// more than 500ms after user input (async pricing recalculation). Because
// hadRecentInput is false, these shifts count as CLS (measured 0.3+ on
// French Door page in CrUX field data).
//
// Solution: Use ResizeObserver to detect APO container height changes.
// ResizeObserver callbacks fire BEFORE paint (per spec), so we can lock
// the container at its previous height and then smoothly transition to
// the new height — preventing the abrupt visual shift.
(function () {
  var container = null;
  var lastHeight = 0;
  var isTransitioning = false;

  function init() {
    container = document.querySelector('.mw-apo-container');
    if (!container || typeof ResizeObserver === 'undefined') return;

    lastHeight = container.offsetHeight;
    // Skip stabilization during APO's initial render (first 3s after init).
    // The initial expansion (55px → 2700px) should happen naturally.
    var ready = false;
    setTimeout(function () {
      ready = true;
    }, 3000);

    var ro = new ResizeObserver(function (entries) {
      if (isTransitioning || !ready) {
        lastHeight = entries[0].contentRect.height;
        return;
      }

      var newHeight = entries[0].contentRect.height;
      var delta = Math.abs(newHeight - lastHeight);

      // Only stabilize significant height changes (>30px avoids micro-jitter)
      if (lastHeight > 0 && delta > 30) {
        isTransitioning = true;

        // Lock at previous height before browser paints
        container.style.minHeight = lastHeight + 'px';
        container.style.overflow = 'hidden';

        // Next frame: transition to new natural height
        requestAnimationFrame(function () {
          var TRANSITION_MS = 200;
          container.style.transition =
            'min-height ' + TRANSITION_MS + 'ms ease-out';
          container.style.minHeight = newHeight + 'px';

          var cleanupTimeout;
          var hasCleanedUp = false;
          var cleanup = function () {
            if (hasCleanedUp) return;
            hasCleanedUp = true;
            clearTimeout(cleanupTimeout);
            container.removeEventListener('transitionend', cleanup);
            container.style.minHeight = '';
            container.style.overflow = '';
            container.style.transition = '';
            isTransitioning = false;
            lastHeight = container.offsetHeight;
          };
          container.addEventListener('transitionend', cleanup);
          // Fallback if transitionend doesn't fire (e.g. display:none parent)
          cleanupTimeout = setTimeout(cleanup, TRANSITION_MS + 100);
        });
      } else {
        lastHeight = newHeight;
      }
    });

    ro.observe(container);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
